import { Directive, ElementRef, Input } from '@angular/core';
import { GlobalService } from 'src/app/services/global/global.service';

@Directive({
  selector: '[appBackgroundImg]'
})
export class BackgroundImgDirective {
  // @Input() profilePicture: string | null | undefined;
  @Input('appBackgroundImg') bgPicture: any;
  @Input('iType') iType: any = '';
  public imageURL: string = GlobalService.imageURL;
  constructor(private element: ElementRef,) {}
  
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.applyBackgroundImage();
  }
  private applyBackgroundImage() {
    const divElement = this.element.nativeElement;
    let backgroundValue = '';
    // if profile picture available 
    if (this.bgPicture) {
      if (this.bgPicture.includes('https')) {
        backgroundValue = `url(${this.bgPicture})`;
        const img = new Image();
        img.src = this.bgPicture;
        img.onload = () => {
          backgroundValue = 'url("' + this.bgPicture + '"}';
          divElement.style.background = backgroundValue;
        };
        img.onerror = () => {
          backgroundValue = this.getImage()
          divElement.style.background = backgroundValue;
        };
      } else {
        // if profile pic available but the url does not have image
        const profilePictureUrl = this.imageURL + this.bgPicture;
        // const profilePictureUrl =  this.bgPicture;
        const img = new Image();
        img.src = profilePictureUrl;
        img.onload = () => {
          backgroundValue = `url(${profilePictureUrl})`;
          divElement.style.background = backgroundValue;
        };
        img.onerror = () => {
          // Fallback image URL
          // backgroundValue = `url(assets/images/icons/employee.png)`;
          backgroundValue = this.getImage()
          divElement.style.background = backgroundValue;
        };
      }
    }
    else {
      // Fallback image URL (no profile pic)
      // backgroundValue = `url(assets/images/icons/employee.png)`;
      backgroundValue = this.getImage();
    }

    divElement.style.background = backgroundValue;
  }

  getImage() {
    let defaultImg;
    if (this.iType == 'forum') {
      defaultImg = `url(assets/images/forum.png)`
    }
    else if (this.iType == 'course') {
      defaultImg = `url(assets/images/object_icons/default_course.png)`
    }
    else if (this.iType == 'package') {
      // defaultImg=`url(assets/images/package/package_placeholder.png)`
      defaultImg = `url(assets/images/package/pachage-common-im.svg)`
    }
    else if (this.iType == 'company_logo') {
      defaultImg = `url(assets/images/logo/logo.svg)`
    }
    else if (this.iType == 'manager') {
      defaultImg = `url(assets/images/icons/manager.png)`
    }
    // the below is for thank you page
    else if (this.iType == 'thank_you') {
      defaultImg = `url(assets/images/icons/order_purchased_placeholder.svg)`
    }
    else {
      defaultImg = `url(assets/images/icons/employee.png)`;
    }
    return defaultImg
  }
}
